import { createAction } from '@ngrx/store';
import { createEntityEvent } from '../../../shared/base';

export const AssignedVendorToSubcategoryEvent = createEntityEvent<any>('AssignedVendorToSubcategoryEvent');
